import { motion } from "motion/react";

const sentence = [
  { text: "Driven", highlight: false },
  { text: "by", highlight: false },
  { text: "passion.", highlight: true },
  { text: "Backed", highlight: false },
  { text: "by", highlight: false },
  { text: "expertise.", highlight: true },
  { text: "We", highlight: false },
  { text: "turn", highlight: false },
  { text: "complex", highlight: false },
  { text: "systems", highlight: false },
  { text: "into", highlight: false },
  { text: "simple,", highlight: false },
  { text: "seamless", highlight: true },
  { text: "realities", highlight: false },
  { text: "for", highlight: false },
  { text: "your", highlight: false },
  { text: "business.", highlight: false },
];

export default function QuotationFirst() {
  return (
    <section className="relative py-24 md:py-36 lg:py-48 flex flex-col items-center justify-center overflow-hidden gap-12 md:gap-16">
      {/* Ambient glow */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="w-96 h-32 bg-violet-600/10 blur-3xl rounded-full" />
      </div>

      <div className="relative max-w-5xl mx-auto px-6 text-center">
        <p className="font-orbitron font-bold text-3xl md:text-4xl lg:text-5xl xl:text-6xl leading-[1.15] tracking-tight flex flex-wrap justify-center gap-x-[0.35em] gap-y-2">
          {sentence.map((word, i) => (
            <motion.span
              key={i}
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.5 }}
              transition={{ duration: 0.45, delay: i * 0.07, ease: "easeOut" }}
              className={word.highlight ? "text-brand-purple font-extrabold" : "text-white font-bold"}
            >
              {word.text}
            </motion.span>
          ))}
        </p>
      </div>
    </section>
  );
}
